import { v4 as uuid } from 'uuid';

import { getLanguageFromLocale, DOCUMENTS } from '@ratehub/base-ui';
import {
    MortgageDocument,
    PURPOSES,
    SUBMISSION_SOURCES,
    getTransactionTypeFromPurpose,
} from '@ratehub/documents/mtg-journey-document/stable';


function createMortgageJourneyDocument({
    purpose,
    locale,
    source,
    sessionStore,
}) {
    const language = getLanguageFromLocale(locale);
    const journeyID = uuid();
    const primaryContactID = uuid();

    if (source === SUBMISSION_SOURCES.CALCULATOR) {
        return MortgageDocument.create({
            id: journeyID,
            journey: {
                id: journeyID,
                purpose,
                application: {
                    metadata: {
                        documentSource: source,
                    },
                },
            },
        });
    }

    const snapshot = sessionStore.addProfileDataToDocumentSnapshot(DOCUMENTS.MORTGAGE_JOURNEY.TYPE, {
        id: journeyID,
        journey: {
            id: journeyID,
            purpose,
            contacts: [ {
                id: primaryContactID,
                applicationRank: 1, // need to have a single primary applicant
                language,
            } ],
            mortgage: {
                // Default options
                amortization: isPurchaseScenario(purpose) // renewal+refinance have an amortization question
                    ? 25 * 12
                    : undefined,
                paymentFrequencyType: 'monthly',
            },
            ...(!isPurchaseScenario(purpose)
                ? {
                    subjectProperty: {
                        contactPropertyMetadata: [ {
                            contact: primaryContactID,
                            currentAddress: true,
                            ownProperty: true,
                            hasMortgage: false,
                            livesAt: false,
                            livesWithParents: false,
                        } ],
                    },
                }
                : {}
            ),
            application: {
                metadata: {
                    documentSource: source,
                },
            },
        },
    });

    return MortgageDocument.create(snapshot);
}

function isPurchaseScenario(purpose) {
    return getTransactionTypeFromPurpose(purpose) === PURPOSES.PURCHASE;
}

export default createMortgageJourneyDocument;
